// Reducer extracted from UnitPlanModule.js

import _ from "lodash";
import update from "immutability-helper";
import React from "react";
import { generateRandomId } from "Utils";
import {
  UPDATE_FILTER_OBJECT,
  UPDATE_LEARNING_COURSE_FILTER_OBJECT,
  INIT_FILTER_OBJECT,
  SET_CURRENT_TAB,
  SET_CURRENT_UNIT_PLAN_TITLE,
  UPDATE_LOCAL_RESOURCE,
  INIT_LOCAL_RESOURCE,
  SET_UNIT_PLAN_MODE,
  SET_PROMPTS_VISIBILITY,
  SET_DIRECT_CREATE_UNIT_PLAN_MODE,
  SET_UNIT_PLAN_READ_ONLY,
  SWITCH_YEARLY_VIEW,
  SET_UNIT_PLAN_EVIDENCE_VIEW,
  SET_UNIT_PLAN_COUNT,
  SET_CURRENT_VIEW_TYPE,
  RESET_CURRENT_VIEW_TYPE,
  SET_COLLAPSABLE_DESC,
  SET_ACTIVE_UNIT_PLAN_ID,
  SET_ACTIVE_OWNER_UNIT_PLAN_ID,
  SET_CUSTOM_RIGHT_PANE,
  SET_SHOW_LEFT_PANE,
  TOGGLE_TODDLEPLAY,
  TOGGLE_UNITPLAN_VIEW,
  UPDATE_DISPLAY_SETTINGS,
  UPDATE_IMPORT_UNIT_FILTER_OBJECT,
  INIT_IMPORT_UNIT_FILTER_OBJECT,
  SET_SELECTED_IMPORT_UNIT_PLAN,
  SET_BULK_IMPORT_UNIT_PLANS,
  UPDATE_COMBINED_LIBRARY_FILTER,
  UPDATE_TODDLE_LIBRARY_FILTER,
  UPDATE_TODDLE_LIBRARY_UNIT_FEED_FILTER,
  UPDATE_PLANNER_ELEMENT_SETS,
  UPDATE_TODDLE_LIBRARY_UNIT_PLAN_DETAILS,
  RESET_TODDLE_LIBRARY_UNIT_PLAN_DETAILS,
  UPDATE_TODDLE_LIBRARY_COURSE_INFO,
  SET_SCROLL_FIELD,
  SET_UNIT_AI_CONTEXT,
  DEFAULT_TODDLE_LIBRARY_UNIT_PARAMS,
  defaultOrderConstants,
  unitPlanDefaultFilters,
  UPDATE_COURSE_FILTER_SEARCH_TEXT,
  UPDATE_CLASS_FILTER_SEARCH_TEXT,
  UPDATE_INCLUDE_REFLECTIONS_OPTION,
} from "./UnitPlanConstants";

// Initial State
const initialState = {
  orderConstants: defaultOrderConstants,
  filters: unitPlanDefaultFilters,
  unitPlanMode: "edit",
  showPrompts: true,
  directCreateUnitPlanMode: false,
  unitPlanTitle: null,
  readOnly: false,
  evidenceView: false,
  currentTab: null,
  showYearlyView: false,
  currentViewType: null,
  isSinglePageView: true,
  resourceObject: {
    id: "",
    title: "",
    type: "",
    description: "",
    attachments: [],
    attachment: null,
  },
  unitOrderingDisplaySetting: {
    group_by_unit_type: true,
    sort: {
      TITLE: false,
      UPDATED_AT: false,
      START_DATE: true,
      CUSTOM: false,
    },
    display: {
      subjects: true,
      unit_hours: true,
      duration_month: true,
      level: true,
      duration_week: true,
      learning_experiences: true,
      assessments: true,
      collaborators: true,
      shared_with_students_family: true,
      show_blueprint_lock: true,
      owner: true,
    },
  },
  activeUnitPlanId: null,
  activeOwnerUnitPlanId: null,
  showCollapsableDesc: false,
  importUnitFilters: {
    grades: null,
    searchText: "",
    academicYears: null,
    createdBy: null,
    subjects: null,
    unitTypes: [],
    classes: [],
    learningCourses: [],
  },
  // separated state for searchTexts so that DS filter menu
  // only recieves required filters and doesn't reset its state
  // which causes options to get automatically deselecting after searching
  importSearchTexts: {
    classFilterSearchText: "",
    courseFilterSearchText: "",
  },
  toddleLibraryFilters: {
    searchText: "",
    grade: {},
    subject: {},
    unitType: {},
    ibThemes: [],
    feedType: {},
  },
  toddleLibraryUnitFeedFilters: {
    searchText: "",
    grades: [],
    subjects: [],
    unitType: {},
    ibThemes: [],
    types: {},
  },
  toddleLibraryUnitPlanDetails: {
    selectedTemplate: null,
  },
  selectedImportUnitPlan: null,
  bulkImportUnitPlans: [],
  isToddlePlay: false,
  currentPlannerElementSets: {},
  courseSelectionInfo: {
    courseId: null,
    curriculumProgram: {},
  },
  combinedLibrary: {
    filters: {},
  },
  customRightPane: "",
  showLeftPane: null,
  unitPlanCount: null,
  scrollField: null,
  learningCourseFilters: {
    classes: [],
  },
  ai: {
    selectedContext: "UNIT_PLAN",
  },
  isIncludeReflectionsOptionSelected: true,
};

// Reducer Handlers
const REDUCER_HANDLERS = {
  [INIT_FILTER_OBJECT]: (state, action) => {
    return update(state, {
      filters: { $set: _.cloneDeep(initialState.filters) },
    });
  },
  [UPDATE_FILTER_OBJECT]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        filters: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [UPDATE_LEARNING_COURSE_FILTER_OBJECT]: (state, action) => {
    const params = action.data;
    Object.keys(params).map(key => {
      state = update(state, {
        learningCourseFilters: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [UPDATE_DISPLAY_SETTINGS]: (state, action) => {
    return update(state, { unitOrderingDisplaySetting: { $set: action.data } });
  },
  [INIT_IMPORT_UNIT_FILTER_OBJECT]: (state, action) => {
    return update(state, {
      importUnitFilters: {
        $set: _.cloneDeep({ ...initialState.filters, ...action.data }),
      },
    });
  },
  [SET_SELECTED_IMPORT_UNIT_PLAN]: (state, action) => {
    return update(state, { selectedImportUnitPlan: { $set: action.data } });
  },
  [SET_BULK_IMPORT_UNIT_PLANS]: (state, action) => {
    return update(state, { bulkImportUnitPlans: { $set: action.data } });
  },
  [UPDATE_IMPORT_UNIT_FILTER_OBJECT]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        importUnitFilters: {
          [key]: { $set: params[key] },
        },
      });
    });

    return state;
  },
  [SET_CURRENT_TAB]: (state, action) => {
    return update(state, { currentTab: { $set: action.data } });
  },
  [SET_CURRENT_UNIT_PLAN_TITLE]: (state, action) => {
    return update(state, { unitPlanTitle: { $set: action.data } });
  },
  [SET_CURRENT_VIEW_TYPE]: (state, action) => {
    return update(state, { currentViewType: { $set: action.data } });
  },
  [SET_COLLAPSABLE_DESC]: (state, action) => {
    return update(state, { showCollapsableDesc: { $set: action.data } });
  },
  [SET_ACTIVE_UNIT_PLAN_ID]: (state, action) => {
    return update(state, { activeUnitPlanId: { $set: action.data } });
  },
  [SET_ACTIVE_OWNER_UNIT_PLAN_ID]: (state, action) => {
    return update(state, { activeOwnerUnitPlanId: { $set: action.data } });
  },
  [SET_CUSTOM_RIGHT_PANE]: (state, action) => {
    return update(state, { customRightPane: { $set: action.data } });
  },
  [SET_SHOW_LEFT_PANE]: (state, action) => {
    return update(state, { showLeftPane: { $set: action.data } });
  },
  [RESET_CURRENT_VIEW_TYPE]: (state, action) => {
    return update(state, {
      currentViewType: { $set: initialState.currentViewType },
    });
  },

  [SWITCH_YEARLY_VIEW]: (state, action) => {
    return update(state, { showYearlyView: { $set: action.data } });
  },
  [UPDATE_LOCAL_RESOURCE]: (state, action) => {
    const params = action.data;

    Object.keys(params).map((key, index) => {
      state = update(state, {
        resourceObject: { [key]: { $set: params[key] } },
      });
    });

    return state;
  },
  [INIT_LOCAL_RESOURCE]: (state, action) => {
    return update(state, {
      resourceObject: {
        $set: { ...initialState.resourceObject, id: generateRandomId() },
      },
    });
  },
  [SET_UNIT_PLAN_MODE]: (state, action) => {
    return update(state, { unitPlanMode: { $set: action.data } });
  },
  [SET_PROMPTS_VISIBILITY]: (state, action) => {
    return update(state, { showPrompts: { $set: action.data } });
  },
  [SET_DIRECT_CREATE_UNIT_PLAN_MODE]: (state, action) => {
    return update(state, { directCreateUnitPlanMode: { $set: action.data } });
  },
  [SET_UNIT_PLAN_READ_ONLY]: (state, action) => {
    return update(state, { readOnly: { $set: action.data } });
  },
  [TOGGLE_TODDLEPLAY]: (state, action) => {
    return update(state, {
      isToddlePlay: { $set: action.data },
    });
  },
  [TOGGLE_UNITPLAN_VIEW]: (state, action) => {
    return update(state, {
      isSinglePageView: { $set: action.data },
    });
  },
  [SET_SCROLL_FIELD]: (state, action) => {
    return update(state, {
      scrollField: { $set: action.data },
    });
  },
  [SET_UNIT_AI_CONTEXT]: (state, action) => {
    return update(state, {
      ai: {
        selectedContext: { $set: action.data },
      },
    });
  },
  [UPDATE_COMBINED_LIBRARY_FILTER]: (state, action) => {
    const data = action.data;
    return _.reduce(
      data,
      (result, item) => {
        const { key, value } = item;
        return update(result, {
          combinedLibrary: {
            filters: {
              [key]: { $set: value },
            },
          },
        });
      },
      state
    );
  },
  [SET_UNIT_PLAN_EVIDENCE_VIEW]: (state, action) => {
    return update(state, { evidenceView: { $set: action.data } });
  },
  [SET_UNIT_PLAN_COUNT]: (state, action) => {
    return update(state, { unitPlanCount: { $set: action.data } });
  },
  [UPDATE_TODDLE_LIBRARY_FILTER]: (state, action) => {
    const { params } = action.payload;
    _.forEach(params, (value, key) => {
      state = update(state, {
        toddleLibraryFilters: {
          [key]: { $set: value },
        },
      });
    });
    return state;
  },
  [UPDATE_TODDLE_LIBRARY_UNIT_FEED_FILTER]: (state, action) => {
    const { params } = action.payload;
    _.forEach(params, (value, key) => {
      state = update(state, {
        toddleLibraryUnitFeedFilters: {
          [key]: { $set: value },
        },
      });
    });
    return state;
  },
  [UPDATE_TODDLE_LIBRARY_UNIT_PLAN_DETAILS]: (state, action) => {
    const params = action.payload;
    _.forEach(params, (value, key) => {
      state = update(state, {
        toddleLibraryUnitPlanDetails: { [key]: { $set: value } },
      });
    });
    return state;
  },
  [RESET_TODDLE_LIBRARY_UNIT_PLAN_DETAILS]: state => {
    state = update(state, {
      toddleLibraryUnitPlanDetails: {
        $set: DEFAULT_TODDLE_LIBRARY_UNIT_PARAMS,
      },
    });
    return state;
  },
  [UPDATE_PLANNER_ELEMENT_SETS]: (state, action) => {
    const params = action.payload;
    return update(state, {
      currentPlannerElementSets: { $set: params },
    });
  },
  [UPDATE_TODDLE_LIBRARY_COURSE_INFO]: (state, action) => {
    const params = action.payload;
    return update(state, {
      courseSelectionInfo: { $set: params },
    });
  },
  [UPDATE_COURSE_FILTER_SEARCH_TEXT]: (state, action) => {
    const searchText = action.data;
    return update(state, {
      importSearchTexts: {
        courseFilterSearchText: {
          $set: searchText,
        },
      },
    });
  },
  [UPDATE_CLASS_FILTER_SEARCH_TEXT]: (state, action) => {
    const searchText = action.data;
    return update(state, {
      importSearchTexts: {
        classFilterSearchText: {
          $set: searchText,
        },
      },
    });
  },
  [UPDATE_INCLUDE_REFLECTIONS_OPTION]: (state, action) => {
    return update(state, {
      isIncludeReflectionsOptionSelected: { $set: action.data },
    });
  },
};

// Reducer
export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

// Auto-generated exports
export { initialState, REDUCER_HANDLERS };
